import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

interface SEOProps {
  title?: string;
  description?: string;
  canonicalUrl?: string;
  image?: string;
  schemaType?: string;
}

const SEO: React.FC<SEOProps> = ({
  title,
  description,
  canonicalUrl = 'https://anilorhan.dev',
  image = '/favicon/og-image.png',
  schemaType = 'WebSite'
}) => {
  const { t, i18n } = useTranslation();
  
  // Varsayılan değerler
  const defaultTitle = t('seo.title', 'Anıl Orhan | Yazılım Geliştirici & Çözüm Mimarı');
  const defaultDescription = t('seo.description', '.NET, ASP.NET Core, ve web teknolojileri konularında uzmanlaşmış backend developer.');
  const siteTitle = title ? `${title} | Anıl Orhan` : defaultTitle;
  const siteDescription = description || defaultDescription;
  const languageCode = i18n.language.substring(0, 2);
  
  return (
    <Helmet>
      {/* Temel Meta Etiketleri */}
      <html lang={languageCode} />
      <title>{siteTitle}</title>
      <meta name="description" content={siteDescription} />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <link rel="canonical" href={canonicalUrl} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={siteTitle} />
      <meta property="og:description" content={siteDescription} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content={languageCode === 'tr' ? 'tr_TR' : 'en_US'} />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={canonicalUrl} />
      <meta name="twitter:title" content={siteTitle} />
      <meta name="twitter:description" content={siteDescription} />
      <meta name="twitter:image" content={image} />
      
      {/* JSON-LD Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': schemaType,
          name: siteTitle,
          description: siteDescription,
          url: canonicalUrl,
          image,
          author: {
            '@type': 'Person',
            name: 'Anıl Orhan',
            url: 'https://anilorhan.dev'
          }
        })}
      </script>
    </Helmet>
  );
};

export default SEO; 